import { render, staticRenderFns } from "./NavCity.vue?vue&type=template&id=2374e25e&"
import script from "./NavCity.vue?vue&type=script&lang=js&"
export * from "./NavCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports